
<div class="site-panel v-flex" v-if="site">
    <c-inc-maintenance-list
        :site = "site"
        :readonly = "readonly"
    />
</div>
